
//  * 1. Today's date for sending data to API

export const getTodayDate = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
   return `${day}-${month}-${year}`;
};

//  * 2. Max date for input field limitations

export const getMaxDate = (): string => {
  const monthsToAdd = Number(import.meta.env.VITE_MAX_DATE_MONTHS || 1);
  const today = new Date();
  today.setMonth(today.getMonth() + monthsToAdd);
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
   return `${day}-${month}-${year}`;
};

//  Display date in table/card  Input: ISO string or any parseable date 

export const formatDisplayDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "-";
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) return dateString;
  const d = new Date(dateString);
    if (isNaN(d.getTime())) return "-";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`; 
};

export const toISOForDB = (dateStr: string | null | undefined): string | undefined => {
  if (!dateStr) return undefined;

  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) return dateStr;

  const sep = dateStr.includes("-") ? "-" : "/";
  const [day, month, year] = dateStr.split(sep).map(Number);

  if (!day || !month || !year) return undefined;

  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export const formatDisplayDateTime = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return "-";

  const d = new Date(dateString);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

export const formatRecTime = (secs: number) => {
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};

export const validateFutureDate = (value: string) => {
  const isoValue = toISOForDB(value);
  if (!isoValue) return "Invalid date";
  const todayISO = toISOForDB(getTodayDate())!;
  return isoValue >= todayISO || "Next Hearing Date must be in the future";
};